import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { RefreshCw } from 'lucide-react';

export function ListingImageUpdater() {
  const [isUpdating, setIsUpdating] = useState(false);

  const updateListingImages = async () => {
    setIsUpdating(true);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        toast.error('You must be logged in');
        return;
      }

      const response = await supabase.functions.invoke('update-listing-images', {
        headers: {
          Authorization: `Bearer ${session.access_token}`,
        },
      });

      if (response.error) throw response.error;

      toast.success(`Successfully updated ${response.data.updates.length} listings with diverse images!`);
      console.log('Update details:', response.data.updates);
    } catch (error) {
      console.error('Error updating images:', error);
      toast.error('Failed to update listing images');
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Update Test Listing Images</CardTitle>
        <CardDescription>
          Replace test listing images with diverse, professional images matching each business type
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button 
          onClick={updateListingImages} 
          disabled={isUpdating}
          className="w-full"
        >
          {isUpdating ? (
            <>
              <RefreshCw className="mr-2 h-4 w-4 animate-spin" />
              Updating Images...
            </>
          ) : (
            <>
              <RefreshCw className="mr-2 h-4 w-4" />
              Update All Listing Images
            </>
          )}
        </Button>
        <p className="text-sm text-muted-foreground mt-4">
          This will update all listings in the database with appropriate images based on their business type and sector.
        </p>
      </CardContent>
    </Card>
  );
}
